import { Controller } from 'stimulus'

export default class extends Controller {
  static classes = ['hide']
  static targets = ['output']

  connect () {
    // Comments controller is connected and ready
  }

  hidenall(event) {
    // Prevent the default action
    event.preventDefault();
    
    // Find the target comment section
    const targetId = event.params.id;
    
    // Find the specific element
    const targetElement = this.outputTargets.find(el => el.id === targetId);
    
    if (targetElement) {
      const wasHidden = targetElement.classList.contains(this.hideClass);
      
      // First hide all other comment sections
      this.outputTargets.forEach(element => {
        if (element.id !== targetId) {
          element.classList.add(this.hideClass);
        }
      });
      
      // Then toggle the target
      targetElement.classList.toggle(this.hideClass);
    }
  }
}
